import {
  AfterContentInit,
  AfterViewInit,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewChild, ViewChildren
} from '@angular/core';
import {AppComponent} from "../../../app.component";
import {FS3ValidationResult} from "../../../objects/validationResult";
import {AbstractControl, FormControl, FormGroup, ValidatorFn, Validators} from "@angular/forms";
import {environment} from "../../../../environments/environment";
import {FS3Notification} from "../../../objects/notification";
import {AppEvent} from "../../../objects/appEvent";
import {SharedDataService} from "../../../services/shared-data.service";
import {User} from "../../../objects/user";
import {MatAccordion} from "@angular/material/expansion";
import {ListItem} from "../../../objects/listItem";
import {UserDetailsComponentComponent} from "../../mobile/user-details-component/user-details-component.component";
import {ConfirmationDialogComponent} from "../../confirmation-dialog/confirmation-dialog.component";
import {MatDialog} from "@angular/material/dialog";

@Component({
  selector: 'app-friend-invitation',
  templateUrl: './friend-invitation.component.html',
  styleUrls: []
})
export class FriendInvitationComponent implements OnInit, AfterContentInit {
  @HostListener('document:keydown', ['$event']) public onKeyDown($event: KeyboardEvent) {
    $event.stopPropagation();
    if ($event.key === 'Enter') {
      this.handleSubmit()
    }
  }

  @Input() application: AppComponent;
  @Input() payload: object;
  @Output() close = new EventEmitter<void>();
  @Output() success = new EventEmitter<void>();

  state: string = 'default';
  isSearching: boolean = false;
  isUpdating: boolean = false;
  isError: boolean = false;
  errMsg: string = '';
  afterInit: boolean = false;
  minHeight: number = 250;
  profile: User;
  previewMode: boolean = false;
  relationStatus: string
  relationAction: string
  relationParams: object

  private formValidationMessages = {
    required: AppComponent.getLabel('phone_number_required'),
    phoneNumberTooShort: AppComponent.getLabel('phone_number_too_short'),
    phoneNumberTooLong: AppComponent.getLabel('phone_number_too_long'),
  };
  public validationResult: FS3ValidationResult;
  public componentForm: FormGroup = new FormGroup({});
  public phoneInput: FormControl = new FormControl('', [Validators.required, this.formValidator()]);
  public shareInput: FormControl = new FormControl('');

  constructor(public confirmationDialog: MatDialog,
              private sharedDataService: SharedDataService) { }

  ngOnInit(): void {
    this.componentForm.addControl('phoneInput', this.phoneInput);
    this.componentForm.addControl('shareInput', this.shareInput);
    this.phoneInput.setValue('+380');
    //this.phoneInput.setValue('+380969533903');
    this.shareInput.setValue('viber://pa?chatURI=squashfitcenterlviv&context=__referral_'+this.application.user.id);
    if(this.payload['profile']) {
      this.previewMode = true;
      this.profile = this.payload['profile'];
      this.assessProfile(true)
    }
  }
  ngAfterContentInit() {
    setTimeout( ( ) => { this.afterInit = true },1000)
  }

  private formValidator(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
      const phoneNumberStr = control.value.replace(/[^\d]/g,'');
      if (!phoneNumberStr) {
        return {required: this.formValidationMessages.required}
      }

      // if ((phoneNumberStr.substr(0,2) != '38' && phoneNumberStr.length < 10 ) ||
      //     (phoneNumberStr.substr(0,2) == '38' && phoneNumberStr.length < 12)
      // ) {
      //   return {phoneNumberTooShort: this.formValidationMessages.phoneNumberTooShort}
      // }
      // if (
      //     (phoneNumberStr.substr(0,2) == '38' && phoneNumberStr.length > 12)) {
      //   return {phoneNumberTooLong: this.formValidationMessages.phoneNumberTooLong}
      // }
      if (phoneNumberStr.length < 10) {
        return {phoneNumberTooShort: this.formValidationMessages.phoneNumberTooShort}
      }
      if (phoneNumberStr.length > 13) {
        return {phoneNumberTooLong: this.formValidationMessages.phoneNumberTooLong}
      }

      return null;
    };
  }

  public copyLink(event: Event | void = null): void {
    if (event) {
      event.stopPropagation();
    }
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = this.shareInput.value;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.sharedDataService.pushNotification({ text: AppComponent.getLabel('link_copied'), type: 'success' })
    this.onNoClick()
  }

  public showUser(user): void {
    this.onNoClick();
    this.application.router.navigateByUrl('/squash/userview/'+user.id)
  }

  public onNoClick(): void {
    //this.dialogRef.close({ isConfirmed: false });
    this.close.emit()
  }

  public handleSubmit(event: Event | void = null): void {
    if (event) {
      event.stopPropagation();
    }

    if (!this.phoneInput.valid) {
      this.phoneInput.markAsTouched()
      const errorKey = Object.keys(this.phoneInput.errors)[0]; // get error key from input errors
      this.validationResult = {
        isValid: false,
        message: this.phoneInput.errors[errorKey] // get error string by errorKey
      };
      return
    }
    this.validationResult = null; //hide validationResult leftovers
    const phoneNumberStr = this.phoneInput.value.replace(/[^\d]/g,'');
    this.searchUser(phoneNumberStr);
    //this.success.emit()
  }
  private searchUser(param) {
    this.isSearching = true;
    this.isError = false;

    this.application.apiService
      .searchUserByPhone(
        environment['gid'],environment['g_hash'],param)
      .subscribe(
        data => {
          this.isSearching = false;
          this.profile = data as User;
          this.assessProfile();
        },
        error => {
          const { exception } = error;
          const errMsg = error['errMsg'] ? error['errMsg'] : (
            (exception && exception.error && exception.error.message) ? exception.error.message : 'Error'
          );
          this.state = 'edit'
          this.isError = true;
          this.validationResult = {
            isValid: false,
            message: errMsg
          };
        }
      )
  }
  private assessProfile(viewAsSource:boolean = false) {
    this.minHeight = 380;
    if(viewAsSource) {
      this.relationStatus = User.getRelationStatus(this.application.user,this.profile.id);
      this.relationAction = User.getRelationAction(this.application.user,this.profile.id);
      this.relationParams = UserDetailsComponentComponent.makeRelationParams(this.relationStatus,this.relationAction,this.profile.id,this.application.user,viewAsSource);
    } else {
      this.relationStatus = User.getRelationStatus(this.profile,this.application.user.id);
      this.relationAction = User.getRelationAction(this.profile,this.application.user.id);
      this.relationParams = UserDetailsComponentComponent.makeRelationParams(this.relationStatus,this.relationAction,this.application.user.id,this.profile,viewAsSource);
    }
    //console.log('this.relationParams',this.relationParams,this.relationStatus)
  }
  private updateRelation(action_type) {
    if(action_type == 'remove_from_friends') {
      const dialogRef = this.confirmationDialog.open(ConfirmationDialogComponent, {
        width: '22vw',
        height: '18vh',
        autoFocus: false,
        panelClass: 'common-dialog',
        data: {
          title: AppComponent.getLabel('remove_from_friends_popup_title'),
          message: AppComponent.getLabel('remove_from_friends_popup_description') + this.profile.shipping_name,
          cancelLabel: AppComponent.getLabel('close'),
          actionLabel: AppComponent.getLabel('confirm'),
        }
      });
      dialogRef.afterClosed()
        .subscribe((result) => {
          if (result && result.isConfirmed) {
            this.doUpdateRelation(action_type);
          }
        })
    } else {
      this.doUpdateRelation(action_type);
    }
  }
  private doUpdateRelation(action_type) {
    const pid = this.profile.id;
    this.isUpdating = true;
    this.application.apiService
      .relationConfirmation(environment['gid'],environment['g_hash'],pid,0,action_type)
      .subscribe(
        data => {
          this.isUpdating = false;
          let notification = new FS3Notification();
          switch (action_type) {
            case 'friendship_request':
            case 'approve_as_friends':
              notification.type = 'success';
              break;
            case 'remove_from_friends':
              notification.type = 'error';
              break;
          }
          notification.text = this.relationParams['action_confirmation_label'];
          this.sharedDataService.pushNotification(notification);
          // go to fresh friends list
          let appEvent = new AppEvent(AppEvent.SHOW_FRESH_RELATIONS,{});
          this.sharedDataService.pushAppEvent(appEvent)

          this.onNoClick(); //close popup
        },
        error => {
          this.isUpdating = false;
          const { exception } = error;
          if (exception && exception.error && exception.error.message) {
            let notification = new FS3Notification();
            notification.type = 'error';
            notification.text = exception.error.message;
            this.sharedDataService.pushNotification(notification);
          }
        }
      )
  }
}
